<template>
  <v-dialog :value="visible" @input="onDialogInput" persistent max-width="850">
    <v-card elevation="24" class="border-radius policeLato">
      <v-card-text style="background:#FAFAFA">
        <div class="wizard-tab-content">
          <div role="tabpanel" id="EditHousingInfo" class="wizard-tab-container">
            <div>
              <div class="loan-group loan-group-0">
                <div class="fields">
                  <div class="field-title font-weight-bold">Modifier le logement&nbsp;:</div>

                  <!-- IDENTIFICATION -->
                  <div class="row mt-3">
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_typeBien" class="field-label">Type de bien <span class="required-star">*</span></label>
                        <select v-model="form.typeBien" id="edit_typeBien" class="field-select">
                          <option value="">—</option>
                          <option value="appartement">Appartement</option>
                          <option value="maison">Maison (max R+2)</option>
                          <option value="immeuble">Immeuble</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_adresse" class="field-label">Adresse du logement <span class="required-star">*</span></label>
                        <input type="text" v-model="form.adresselogement" id="edit_adresse" class="field-input">
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_superficie" class="field-label">Superficie (m²) <span class="required-star">*</span></label>
                        <input type="number" min="4" v-model="form.superficie" id="edit_superficie" class="field-input">
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_nombrepiece" class="field-label">Nombre de pièces <span class="required-star">*</span></label>
                        <input type="number" min="1" v-model="form.nombrepiece" id="edit_nombrepiece" class="field-input">
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_nombreetage" class="field-label">Nombre d'étages</label>
                        <input type="number" min="0" v-model="form.nombreetage" id="edit_nombreetage" class="field-input">
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="field-group field-default">
                        <label for="edit_naturecouverture" class="field-label">Nature de couverture</label>
                        <select v-model="form.naturecouverture" id="edit_naturecouverture" class="field-select">
                          <option value="">—</option>
                          <option value="Béton">Béton</option>
                          <option value="Tuile (ardoise)">Tuile (ardoise)</option>
                          <option value="Tôle metal">Tôle metal</option>
                          <option value="Paille">Paille</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-sm-6">
                      <div class="field-group field-default">
                        <label for="edit_environnement" class="field-label">Environnement immédiat</label>
                        <select v-model="form.environnement_immediat" id="edit_environnement" class="field-select">
                          <option value="">—</option>
                          <option value="Quartier résidentiel">Quartier résidentiel</option>
                          <option value="Chantiers à proximité">Chantiers à proximité</option>
                          <option value="Proche Usine/Marche/Station Essence">Proche Usine/Marche/Station Essence</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="field-group field-default">
                        <label for="edit_qualiteassure" class="field-label">Qualité assuré <span class="required-star">*</span></label>
                        <select v-model="form.qualiteassure" id="edit_qualiteassure" class="field-select">
                          <option value="">—</option>
                          <option value="locataire">Locataire</option>
                          <option value="proprio_occupant">Propriétaire occupant</option>
                          <option value="proprio_non_occupant">Propriétaire non-occupant</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3" v-if="form.qualiteassure === 'locataire'">
                    <div class="col-sm-6">
                      <div class="field-group field-default">
                        <label for="edit_montaLoyer" class="field-label">Montant du loyer (FCFA) <span class="required-star">*</span></label>
                        <input type="number" min="50000" v-model="form.montaLoyer" id="edit_montaLoyer" class="field-input" @change="calculateValeurBatiment">
                        <small style="color: #999;">Minimum 50,000 FCFA</small>
                      </div>
                    </div>
                  </div>

                  <!-- VALEURS -->
                  <div class="row mt-3">
                    <div class="col-sm-6">
                      <div class="field-group field-default">
                        <label for="edit_valeurcontenu" class="field-label">Valeur du contenu (FCFA)</label>
                        <input type="number" min="0" v-model="form.valeurcontenu" id="edit_valeurcontenu" class="field-input">
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="field-group field-default">
                        <label for="edit_valeurbatiment" class="field-label">Valeur du bâtiment (FCFA) <span v-if="form.qualiteassure === 'locataire'" style="color: #999;">(calculée)</span></label>
                        <input type="number" min="0" v-model="form.valeurbatiment" id="edit_valeurbatiment" class="field-input" :readonly="form.qualiteassure === 'locataire'">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="wizard-card-footer clearfix">
          <div class="wizard-footer-left">
            <button @click="cancel" type="button" class="wizard-btn" :disabled="saving">
              <span class="fas fa-arrow-left"></span>
              Retour
            </button>
          </div>
          <div class="wizard-footer-right">
            <button @click="save" type="button" class="wizard-btn" :disabled="saving">
              <span v-if="saving" class="fas fa-spinner fa-spin"></span>
              {{ saving ? 'Enregistrement...' : 'Enregistrer' }}
            </button>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import HousingService from '../services/portefeuille/HousingService'

const EMPTY_FORM = () => ({
  habitationid: '',
  typeBien: '',
  nombreetage: '',
  nombrepiece: '',
  naturecouverture: '',
  adresselogement: '',
  valeurcontenu: '',
  valeurbatiment: '',
  superficie: '',
  qualiteassure: '',
  environnement_immediat: '',
  montaLoyer: '',
  type_habitation: '',
  type_batiment: '',
  situation: '',
  montant: ''
})

export default {
  name: 'EditHousingDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    housing: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: EMPTY_FORM(),
      saving: false
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.populateForm()
      }
    },
    housing() {
      if (this.visible) {
        this.populateForm()
      }
    }
  },
  methods: {
    onDialogInput(value) {
      if (!value) {
        this.$emit('close')
      }
    },
    populateForm() {
      const h = this.housing || {}
      this.form = {
        ...EMPTY_FORM(),
        habitationid: h._id || h.id || '',
        typeBien: h.typeBien || '',
        nombreetage: h.nombreetage || '',
        nombrepiece: h.nombrepiece || '',
        naturecouverture: h.naturecouverture || '',
        adresselogement: h.adresselogement || '',
        valeurcontenu: h.valeurcontenu || '',
        valeurbatiment: h.valeurbatiment || '',
        superficie: h.superficie || '',
        qualiteassure: h.qualiteassure || '',
        environnement_immediat: h.environnement_immediat || '',
        montaLoyer: h.montaLoyer || '',
        type_habitation: h.type_habitation || '',
        type_batiment: h.type_batiment || '',
        situation: h.situation || '',
        montant: h.montant || ''
      }
    },
    toNumber(value) {
      if (value === '' || value === null || value === undefined) return ''
      const n = Number(value)
      return isNaN(n) ? value : n
    },
    buildPayload() {
      const f = this.form
      return {
        habitationid: f.habitationid,
        typeBien: f.typeBien,
        nombreetage: this.toNumber(f.nombreetage),
        nombrepiece: this.toNumber(f.nombrepiece),
        naturecouverture: f.naturecouverture,
        adresselogement: f.adresselogement,
        valeurcontenu: this.toNumber(f.valeurcontenu),
        valeurbatiment: this.toNumber(f.valeurbatiment),
        superficie: f.superficie,
        qualiteassure: f.qualiteassure,
        environnement_immediat: f.environnement_immediat,
        montaLoyer: this.toNumber(f.montaLoyer),
        type_habitation: f.type_habitation,
        type_batiment: f.type_batiment,
        situation: f.situation,
        montant: this.toNumber(f.montant)
      }
    },
    calculateValeurBatiment() {
      if (this.form.qualiteassure === 'locataire' && this.form.montaLoyer) {
        const loyer = Number(this.form.montaLoyer)
        if (!isNaN(loyer) && loyer >= 50000) {
          this.form.valeurbatiment = Math.round(loyer * 180)
        }
      }
    },
    showToast(message, type) {
      this.$toasted.clear()
      this.$toasted.show(message, {
        theme: 'toasted-primary',
        position: 'top-center',
        type: type || 'error',
        duration: 3000,
        singleton: true
      })
    },
    cancel() {
      this.$emit('close')
    },
    async save() {
      if (!this.form.habitationid) {
        this.showToast("L'identifiant du logement est requis")
        return
      }
      if (!this.form.typeBien) {
        this.showToast('Le type de bien est obligatoire')
        return
      }
      if (!this.form.adresselogement) {
        this.showToast("L'adresse du logement est obligatoire")
        return
      }
      if (!this.form.nombrepiece) {
        this.showToast('Le nombre de pièces est obligatoire')
        return
      }
      if (!this.form.superficie || Number(this.form.superficie) < 4) {
        this.showToast('La superficie est obligatoire (minimum 4 m²)')
        return
      }
      if (!this.form.qualiteassure) {
        this.showToast('La qualité assuré est obligatoire')
        return
      }
      if (this.form.qualiteassure === 'locataire') {
        if (!this.form.montaLoyer || Number(this.form.montaLoyer) < 50000) {
          this.showToast('Le montant du loyer est obligatoire (minimum 50,000 FCFA)')
          return
        }
        this.calculateValeurBatiment()
      }

      this.saving = true
      try {
        const response = await HousingService.updateHousing(this.form.habitationid, this.buildPayload())
        const msg =
          (response && response.data && (response.data.msg || response.data.message)) ||
          "L'habitation a été mise à jour !"
        this.showToast(msg, 'success')
        this.$emit('saved')
        this.$emit('close')
      } catch (error) {
        const msg =
          (error.response && error.response.data && (error.response.data.msg || error.response.data.message)) ||
          "Erreur lors de la modification du logement"
        this.showToast(msg)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped lang="less">
.field-title {
  font-size: 1.2rem;
  color: #1a1a1a;
}

.required-star {
  color: #e74c3c;
}

.field-group {
  margin-bottom: 0.5rem;
}

.field-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.35rem;
}

.field-input,
.field-select {
  width: 100%;
  height: 42px;
  padding: 0.5rem 0.75rem;
  font-size: 0.95rem;
  color: #333;
  background-color: #fff;
  border: 1px solid #d9dee3;
  border-radius: 8px;
  outline: none;
  box-sizing: border-box;
  font-family: 'Lato', sans-serif;
}

.field-input:focus,
.field-select:focus {
  border-color: #ffa409;
}

.wizard-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.5rem;
  flex-wrap: wrap;
}

.wizard-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ffa409;
  color: #fff;
  border: none;
  padding: 10px 22px;
  border-radius: 50px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.wizard-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.wizard-footer-left .wizard-btn {
  background: transparent;
  color: #666;
  border: 1px solid #ccc;
}
</style>
